// Delivery times are stored as one "h:mm AM/PM" string on each meal plan.

export const parseTime = (t = "") => {
    const [hm = "", ap = ""] = t.split(" ");
    const [h = "", m = ""] = hm.split(":");
    return { h, m, ap };
};

export const buildTime = ({ h, m, ap }) => (h || m || ap ? `${h}:${m} ${ap}` : "");

// "1:45 PM" -> minutes since midnight; unset/invalid sorts last
export const timeToMinutes = (t) => {
    const m = /^(\d{1,2}):(\d{2}) (AM|PM)$/.exec(t || "");
    if (!m) return Infinity;
    return (Number(m[1]) % 12 + (m[3] === "PM" ? 12 : 0)) * 60 + Number(m[2]);
};

export const minutesNow = () => {
    const now = new Date();
    return now.getHours() * 60 + now.getMinutes();
};
